<div class="d-flex mb-3 align-items-center">
  <span>
   <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.3 0.321519C5.8743 0.110865 5.3914 -2.36446e-05 4.89984 3.78167e-09C4.40829 2.36521e-05 3.9254 0.110959 3.49973 0.321654C3.07406 0.532349 2.7206 0.835377 2.47489 1.20028C2.22919 1.56517 2.09989 1.97908 2.1 2.40039V3.46472C1.5043 3.66991 1.0157 3.98909 0.6587 4.40967C0.2044 4.94543 0 5.60119 0 6.30015C0 7.23669 0.5565 8.06164 1.4 8.54521V9.29996C1.39996 9.78888 1.55482 10.2686 1.84806 10.688C2.14129 11.1074 2.5619 11.4507 3.06497 11.6811C3.56804 11.9116 4.1347 12.0207 4.70446 11.9968C5.27422 11.9728 5.82569 11.8166 6.3 11.545V9.29996C6.3 8.50021 6.069 7.98904 5.698 7.64406C5.3179 7.29189 4.7012 7.0297 3.7352 6.89171L3.9648 5.70858C4.8762 5.83818 5.6742 6.08236 6.3 6.49634V0.321519ZM7.7 0.321519V6.49634C8.3258 6.08236 9.1238 5.83818 10.0352 5.70858L10.2648 6.89171C9.2988 7.0297 8.6821 7.29189 8.302 7.64466C7.931 7.98904 7.7 8.50021 7.7 9.29996V11.545C8.17431 11.8166 8.72578 11.9728 9.29554 11.9968C9.8653 12.0207 10.432 11.9116 10.935 11.6811C11.4381 11.4507 11.8587 11.1074 12.1519 10.688C12.4452 10.2686 12.6 9.78888 12.6 9.29996V8.54521C13.4435 8.06164 14 7.23729 14 6.30015C14 5.60119 13.7956 4.94543 13.3413 4.41027C12.9843 3.98909 12.4957 3.66991 11.9 3.46472V2.40039C11.9001 1.97908 11.7708 1.56517 11.5251 1.20028C11.2794 0.835377 10.9259 0.532349 10.5003 0.321654C10.0746 0.110959 9.59171 2.36521e-05 9.10016 3.78167e-09C8.6086 -2.36446e-05 8.1257 0.110865 7.7 0.321519Z" fill="#969696"/>
</svg>

  </span>
  <span class="f-12 font-weight-500 ml-2 text-black">
   Skills
  </span>
</div>
  <div class=" d-flex align-items-baseline mb-3">
            <div class="w-100">

                <div class="d-flex f-12 flex-wrap">
                    <!-- <span class="f-12"> -->
                                        @for(skill of skills; track skill) {

                        <span class="skills-chip  text-capitalize"  [innerHTML]="highlightInfo(skill)"></span>
                            <span class="f-12 pointer text-webbtree-green">
                        </span>
                      }
                    <!-- </span> -->


                </div>
            </div>

        </div>
